import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrSetPersonStatusPayload } from 'api/actions/hr-set-person-status/hr-set-person-status-payload';
import { HrSetPersonStatusPathParameters } from 'api/actions/hr-set-person-status/hr-set-person-status-path-parameters';
import { HrSetPersonStatusResponse } from 'api/actions/hr-set-person-status/hr-set-person-status-response';

type HrSetPersonStatusQueryParameters = Record<string, any>;

/**
 * The path of the HrSetPersonStatus action.
 */
export const hrSetPersonStatusActionPath = new SweetPath<keyof HrSetPersonStatusPathParameters>(
  '/api/hr/people/{personId}/status',
  { path: '{param}' }
);

/**
 * Creates a contextualized HrSetPersonStatus actions.
 */
export default function createHrSetPersonStatusAction(axios: AxiosInstance) {
  return function hrSetPersonStatusAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HrSetPersonStatusPathParameters;
    query?: HrSetPersonStatusQueryParameters;
    payload: HrSetPersonStatusPayload;
  }) {
    const path = hrSetPersonStatusActionPath.insert(parameters);

    return axios.request<HrSetPersonStatusResponse, HrSetPersonStatusResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
